import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import {useCallback} from "react";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import {useStylesTooltip} from "../../../config/theme";
import {Checkbox} from "@material-ui/core";

const useStyles = makeStyles(() => ({
  header: {
    background: '#fff',
    borderRadius: '10px 10px 0px 0px',
    position:'sticky',
    top:-20,
    zIndex:2,
  },
  headerContent: {
    height: 65,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#606B76',
    fontSize: 12,
    borderBottom: '1px solid #D9D9D9',
    textTransform: 'uppercase',
    '& div': {
      textAlign: 'left'
    },
    '@media (max-width: 1025px)': {
      height: 38,
      fontSize: 9,    
    },
  },
  p8: {
    padding: '0 8px'
  },
  headerName: {
    color: '#017AEF',
    display: 'flex',
    justifyContent: 'space-between',
  },
  rotate180: {
    transform: 'rotate(180deg)',
  },
  subClass: {
    height: 40, 
    background: '#E4E9EF',
    padding: '0 8px'
  },
  searchClass: {
    height: 65,
  },
  cursor: {
    cursor: 'pointer',        
  },
   visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  icon: {
    borderRadius: 3,
    width: 18,
    height: 18,
    backgroundColor: '#f5f8fa',
    backgroundImage: "url(\"/assets/icons/dashboard/uncheckbox.svg\")",
  },
  checkedIcon: {
    '&:before': {
      display: 'block',
      width: 21,
      height: 18,
      backgroundImage: "url(\"/assets/icons/dashboard/checkbox.svg\")",
      content: '""',
    },
  },
}));

const CustomSortIconComponent = (order: string, orderBy: string, id: any) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        position: 'absolute',
        right: theme.spacing(-2),         
        width: 14,
        height: 12,
        top: order ? 1 : 0
      },
      icon: {
        width: '100%',
        height: '100%',
        transform: order ? 'rotate(180deg)' : ''
      }
    }),
  );
  const classes = useStyles();

  return (
    (orderBy === id && orderBy !== '') ? (
      <div className={classes.root}>
        <img className={classes.icon} src={'/assets/icons/sort.svg'} alt='sort icon' />
      </div>
    ) : (<></>)
  )
};

export const CreatorTableHeader = (props: any) => {

  const classes = useStyles();
  const tooltipClasses = useStylesTooltip();
  const {
    onClickFilter, filterDirection, data, sub, search, filter, topPosition, isMobile, clipTable, onSelectAllExperiences,
    onSelectAllClips, onClearClips, onClearExperiences, allExpChecked, allClipsChecked
  } = props;

  const isNotSortLabel = useCallback((item: any) => {
    return item.title.toLowerCase() == 'id'
      || item.title.toLowerCase() == 'type'
      || item.title.toLowerCase() == 'survey'
      || item.title.toLowerCase() == 'clips'
      || item.title.toLowerCase() == 'participants'
      || item.title.toLowerCase() == 'owner'
      || clipTable;
  }, [clipTable]);

  const onChangeAll = (isChecked: boolean) => {
    if (isChecked) {
      clipTable ? onSelectAllClips() : onSelectAllExperiences();
    } else {
      clipTable ? onClearClips() : onClearExperiences();
    }
  };

  return (
    <div
      className={clsx(classes.header, !sub && classes.p8)}
      style={isMobile ? { top: -11, borderRadius: 0 } : {top: (topPosition !== undefined ? topPosition : -20)}}
    >
      <div className={clsx(classes.headerContent, (search && sub) && classes.searchClass, sub && classes.subClass)}>
        {search && (
          <Checkbox
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            color="primary"
            checked={clipTable ? allClipsChecked : allExpChecked}
            onChange={(e: any) => onChangeAll(e.target.checked)}
            style={{ marginLeft: -8 }}
          />
        )}
        {
          data.map((item: any, index: number) =>
            isNotSortLabel(item)
              ? (
                <div key={index} style={{ width: item.width }}>
                  {item.title === 'survey' && (
                    <Tooltip classes={tooltipClasses} title="Survey Included in Experience" placement="bottom" arrow>
                      <img src={'/assets/icons/dashboard/survey_icon.svg'} width='18px' height='18px' />
                    </Tooltip>
                  )}
                  {item.title === 'participants' && <img src={'/assets/icons/dashboard/group_icon.svg'} width='18px' height='18px' />}
                  {(item.title !== 'survey' && item.title !== 'participants') && item.title}
                </div>
              ) : (
                <div
                  key={index}
                  style={{ width: item.width }}
                  className={clsx(classes.cursor)}
                  onClick={() => (index !== 0 && !sub && !search && !isMobile) && onClickFilter(index)}
                >
                  <TableSortLabel
                    style={{ color: filter === item.title ?'#017AEF':'' }}
                    active={filter === item.title}
                    direction={filter === item.title ? 'desc' : 'asc'}
                    onClick={() => (!isMobile && onClickFilter) && onClickFilter(index)}
                    IconComponent={() => CustomSortIconComponent(filterDirection, filter, item.title)}
                  >
                    {item.title}
                    {filter === item.title ? (
                      <span className={classes.visuallyHidden}>
                        {filterDirection ? 'sorted descending' : 'sorted ascending'}
                      </span>
                    ) : null}
                  </TableSortLabel>
                </div>
              )
          )
        }
      </div>
    </div>
  )};